export default "__VITE_ASSET__C6xhjQE7__"